import { useDispatch } from 'react-redux';
import { useAsyncAction } from 'Hooks/Common';
import { SignatureRequest } from 'Interfaces/SignatureRequest';
import { $actions } from 'Store/ducks';

export default () => {
  const dispatch = useDispatch();

  return useAsyncAction((signatureRequestIds: SignatureRequest['id'][]) =>
    $actions.signatureRequest.deleteSignatureRequests(dispatch, { signatureRequestIds }),
  );
};
